import { InjectionToken } from '@angular/core';

import { Language } from '../models/language.model';

export type HelpHubItemAction = 'external' | 'internal' | 'mailto';

export interface HelpHubItem {
  /** Stable identifier used for analytics and template tracking. */
  id: string;
  /** Name of the leading `ui-inline-svg` icon. */
  icon: string;
  /** Transloco key for the item title. */
  titleKey: string;
  /** Transloco key for the item description. */
  descriptionKey: string;
  /**
   * `external` opens a link in a new tab, `mailto` opens the user's mail client,
   * `internal` triggers in-app behavior.
   */
  action: HelpHubItemAction;
  /**
   * Destination URL for `external`/`mailto` items.
   * Used as a fallback when no localized URL matches.
   */
  url?: string;
  /** Per-locale destination URLs; takes precedence over `url` for the active language. */
  localizedUrls?: Partial<Record<Language, string>>;
}

export interface HelpHubSection {
  id: string;
  titleKey: string;
  items: HelpHubItem[];
}

export const HELP_HUB_CONTACT_SUBJECTS = [
  'general',
  'technical',
  'billing',
  'feature',
  'other',
] as const;

/** Per-app section/link data, provided by each app's `app.config.ts`. */
export const HELP_HUB_SECTIONS = new InjectionToken<HelpHubSection[]>('helpHubSections');
